import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

/**
 * Función que realiza la exportación a aexcel del contenido enviado como parámetro
 *
 * @param {Array<string>} headers Lista de cabecera de las columnas del Excel
 * @param {Array<any>} records Filas del contenido del Excel
 * @param {string} filename Nombre sugerido para el archivo resultado
 */
export const ExportExcel = async (
  headers: Array<string>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  records: Array<any>,
  filename: string
): Promise<void> => {
  const fileType =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const Heading = [headers];
  const ws = XLSX.utils.json_to_sheet([]);
  XLSX.utils.sheet_add_aoa(ws, Heading);
  XLSX.utils.sheet_add_json(ws, records, { origin: 'A2', skipHeader: true });
  const wb = { Sheets: { data: ws }, SheetNames: ['data'] };

  const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const data = new Blob([excelBuffer], { type: fileType });

  saveAs(data, `${filename}.xlsx`);
};
